import CardSkeleton from '@ifit/mp-card-skeleton';
import { MarketingItem } from './marketing-item';
import RowHeading from '../row-heading';
import { Text } from './text';
import { useMarketingItems } from '../../state-management/server-state/use-marketing-items';
import './index.scss';
import { useMatrixCommercial } from '../../hooks/use-matrix-commercial';
import { useSoftwareNumber } from '../../state-management/selectors/use-software-number';
import { isClub } from '../../util/is-club';

const skeletonCards = Array(10).fill(0);

export default function MarketingRow(): JSX.Element {
  const marketingItemsQuery = useMarketingItems();
  const softwareNumber = useSoftwareNumber();
  const { data, isFetching, error, isLoading, isSuccess } = marketingItemsQuery;
  const isMatrixCommerical = useMatrixCommercial();
  const noValidData = !data || data.length === 0;
  const errorWithNoCachedData = error && noValidData;
  const successWithNoData = noValidData && isSuccess;
  const hideRow = errorWithNoCachedData || successWithNoData || isMatrixCommerical || isClub(softwareNumber);

  if (hideRow) {
    return null;
  }

  let content: JSX.Element[];

  if (isLoading) {
    content = skeletonCards.map((_, index) => <CardSkeleton key={index} className="custom" />);
  } else {
    content = data.map((item) => <MarketingItem key={item.id} item={item} />);
  }

  return (
    <div className="row-marketing">
      <RowHeading title={Text.title} fetching={isFetching} />
      <div className="cards" style={{ ['--cards-per-row' as any]: content.length }}>
        {content}
      </div>
    </div>
  );
}
